// extracted by mini-css-extract-plugin
module.exports = {"input":"TextAreaInput_input__Kpxx8","water":"TextAreaInput_water__7UXJ1","rotate":"TextAreaInput_rotate__glJn1","pulsate":"TextAreaInput_pulsate__49ewQ"};